// Entries
// ======================================================

export class Entry {
  constructor(entryData) {
    this.start = entryData.startTime;
    this.end = entryData.endTime;
    this.comment = entryData.comment;
    this.tags = entryData.tags.flat();
    this.rhythm = entryData.rhythm;
    this.duration = entryData.duration;
  }
}
